import React from 'react';
import { Link } from 'react-router-dom';

export class Title extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      slimFactorFix: false,
    };
  }
  componentDidMount() {
    this.setState({ slimFactorFix: this.props.passedAppFunctions.getFeatureFlagVariation('slimFactorFix') === 'expb' });
  }

  render() {
    var contentData = this.props.contentData,
      brandName = contentData.brandNameForTitle,
      productTitle = contentData.productName || '',
      brandUrl = contentData.brandUrl,
      productTitleUrl = contentData.navState;
    var isQuickView = contentData.productLayout.indexOf('Quick') > -1;
    var isSlim = false;
    if (this.state.slimFactorFix) {
      if (this.props.contentData.productName.indexOf('Slim Factor') > -1) {
        brandName = 'Slim Factor';
        isSlim = true;
      }
    }
    if (this.props.isBundle) {
      return (
        <h2 className='product__title m-b-10'>
          <span className='product__title--brand m-b-10'>
            {isSlim ? <Link to={brandUrl}>{brandName}</Link> : <Link to={brandUrl}>{brandName}</Link>}
          </span>
          <span className='product__title--desc m-b-10'>
            {productTitle.split('#double;').join('"').split('&trade;').join('™')}
          </span>
        </h2>
      );
    }
    if (isQuickView) {
      return (
        <h2 className='product__title m-b-10'>
          <span className='product__title--brand m-b-10'>
            {isSlim ? <Link to={brandUrl}>{brandName}</Link> : <Link to={brandUrl}>{brandName}</Link>}
          </span>
          <span className='product__title--desc m-b-10'>
            <Link to={{ productTitleUrl, state: { fromQv: true } }}>
              {productTitle.split('#double;').join('"').split('&trade;').join('™')}
            </Link>
          </span>
        </h2>
      );
    }

    return (
      <h1 className='product__title m-b-10'>
        <span className='product__title--brand m-b-10'>
          {isSlim ? <Link to={brandUrl}>{brandName}</Link> : <Link to={brandUrl}>{brandName}</Link>}
        </span>

        <span className='product__title--desc m-b-10'>
          {productTitle.split('#double;').join('"').split('&trade;').join('™')}
        </span>
      </h1>
    );
  }
}

export default Title;
